import type React from 'react'
import { useRef } from 'react'

import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { useEventListener } from '../../../hooks'
import useOnCanvasKeyboardActions from './actions/useOnCanvasKeyboardActions'
import useOnCopyKeyboardActions from './actions/useOnCopyKeyboardActions'
import { useOnCursorModeKeyboardActions } from './actions/useOnCursorModeKeyboardActions'
import useOnDeleteKeyboardActions from './actions/useOnDeleteKeyboardActions'
import useOnDuplicateKeyboardActions from './actions/useOnDuplicateKeyboardActions'
import useOnEnterKeyboardActions from './actions/useOnEnterKeyboardActions'
import useOnEscapeKeyboardActions from './actions/useOnEscapeKeyboardActions'
import useOnPasteKeyboardActions from './actions/useOnPasteKeyboardActions'
import useOnTabKeyboardActions from './actions/useOnTabKeyboardActions'
import { useOnToolKeyboardActions } from './actions/useOnToolKeyboardActions'

const KeyboardListener: React.FC = () => {
  const documentRef = useRef<Document>(document)

  const canvasActions = useOnCanvasKeyboardActions()
  const copyActions = useOnCopyKeyboardActions()
  const cursorModeActions = useOnCursorModeKeyboardActions()
  const deleteActions = useOnDeleteKeyboardActions()
  const duplicateActions = useOnDuplicateKeyboardActions()
  const enterActions = useOnEnterKeyboardActions()
  const escapeActions = useOnEscapeKeyboardActions()
  const pasteActions = useOnPasteKeyboardActions()
  const tabActions = useOnTabKeyboardActions()
  const toolActions = useOnToolKeyboardActions()

  const artboardDisabled = useArtBoardDisabled()

  // The artboard is off: a shortcut that edits it stays as silent as the
  // controls on screen. Undo/redo and delete carry the same check inside.
  const whileEnabled =
    (handler: (event: KeyboardEvent) => void) => (event: KeyboardEvent) => {
      if (!artboardDisabled) {
        handler(event)
      }
    }

  useEventListener('keydown', canvasActions, documentRef)
  useEventListener('keydown', copyActions, documentRef)
  useEventListener('keydown', cursorModeActions, documentRef)
  useEventListener('keydown', deleteActions, documentRef)
  useEventListener('keydown', whileEnabled(duplicateActions), documentRef)
  useEventListener('keydown', whileEnabled(enterActions), documentRef)
  useEventListener('keydown', escapeActions, documentRef)
  useEventListener('keydown', whileEnabled(pasteActions), documentRef)
  useEventListener('keydown', tabActions, documentRef)
  useEventListener('keydown', toolActions, documentRef)

  return <div />
}

export default KeyboardListener
